import React, { useState } from 'react';
import axios from 'axios';

const BlogCreator = () => {
  const [image, setImage] = useState(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [contentBlocks, setContentBlocks] = useState(['', '', '']);
  const [notification, setNotification] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        setNotification('Будь ласка, виберіть файл зображення (SVG, PNG, JPG тощо)');
        setImage(null);
        setTimeout(() => setNotification(null), 3000);
        return;
      }
      setImage(file);
    }
  };

  const handleContentChange = (index) => (e) => {
    const newBlocks = [...contentBlocks];
    newBlocks[index] = e.target.value;
    setContentBlocks(newBlocks);
  };

  const uploadImageToCloudinary = async () => {
    if (!image) return null;
    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'ml_default');

    try {
      const res = await axios.post(
        'https://api.cloudinary.com/v1_1/dca5poo9m/image/upload',
        formData
      );
      return res.data.secure_url;
    } catch (error) {
      console.error('Помилка завантаження картинки:', error);
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!image) {
      setNotification('Будь ласка, виберіть зображення');
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    const imageUrl = await uploadImageToCloudinary();
    if (!imageUrl) {
      setNotification('Помилка при завантаженні картинки до Cloudinary');
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    const blogData = {
      title,
      description: description.slice(0, -3) + '...',
      contentBlocks,
      imageUrl,
      createdAt: new Date().toISOString(),
    };

    try {
      const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
      const response = await axios.post(`${serverBaseUrl}/api/blogs`, blogData);
      setNotification(`Блог та картка успішно створені з ID: ${response.data.blog._id}`);
      setTimeout(() => setNotification(null), 3000);

      setImage(null);
      setTitle('');
      setDescription('');
      setContentBlocks(['', '', '']);
      document.querySelector('input[type="file"]').value = '';
    } catch (error) {
      console.error('Помилка збереження в MongoDB:', error);
      setNotification('Помилка при створенні блогу');
      setTimeout(() => setNotification(null), 3000);
    }
  };

  return (
    <div className="blog-creator">
      <h2>Створити новий блог</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Картинка (SVG, PNG, JPG тощо):</label>
          <input
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Заголовок:</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>Короткий опис (для картки):</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows="3"
            required
          />
        </div>
        {contentBlocks.map((block, index) => (
          <div className="form-group" key={index}>
            <label>{`Текстовий блок ${index + 1}:`}</label>
            <textarea
              value={block}
              onChange={handleContentChange(index)}
              rows="5"
              required
            />
          </div>
        ))}
        <button type="submit">Створити блог</button>
      </form>
      {notification && <div className="notification">{notification}</div>}
    </div>
  );
};

export default BlogCreator;